export default "__VITE_ASSET__CfQPIgdv__"